import { useSimMode } from "../SimModeContext";

/** Product-analytics capture signature (a subset of `posthog.capture`). */
export type AnalyticsCapture = (event: string, properties?: Record<string, unknown>) => void;

const NOOP_CAPTURE: AnalyticsCapture = (): void => {};

/**
 * Resolver for product analytics.
 *
 * - External (sim-only) consumers: no `realHooks.capture` injected, so
 *   this returns a no-op. The widget bundle therefore never imports
 *   `posthog-js`, and a docs/marketing demo emits no phantom analytics
 *   events.
 * - apps/main (via `SimRealHooksProvider`): returns the injected
 *   `posthog.capture` wrapper, preserving production instrumentation.
 *
 * Returning a plain function (not calling a hook) keeps this safe to
 * resolve unconditionally.
 */
export function useAnalyticsCapture(): AnalyticsCapture {
    const sim = useSimMode();
    const capture = (sim.realHooks as Record<string, unknown> | undefined)?.["capture"] as AnalyticsCapture | undefined;
    return capture ?? NOOP_CAPTURE;
}
